/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioMensaReportDTO } from '../model/models';
import { ServizioMensaReportListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListServizioMensaReportRequestParams {
    filter: ServizioMensaReportListFilter;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}


export interface ServizioMensaReportServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista filtrata della traccia errori di notifica del servizio mensa.
     * Ritorna gli errori di notifica registrati per il servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id, filtrabili per tipo e finestra temporale (data_da/data_a).
     * @endpoint get /api/v1/servizi/mensa/report
* @param requestParameters
     */
    listServizioMensaReport(requestParameters: ListServizioMensaReportRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaReportDTO>;

}
